import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

/** Privilege = { domain: { action: true } }. */
export type Privilege = Record<string, Record<string, boolean>>;

export interface PrivilegeCatalogItem {
  domain: string;
  label: string;
  grup: string;
  grup_label: string;
  actions: string[];
}

export interface ProfessionRoleRow {
  id: string;
  name: string;
  parent_id: string | null;
  privilege: Privilege | null;
  parent?: ProfessionRoleRow | null;
  children?: ProfessionRoleRow[];
  users?: any[];
  users_count?: number;
}

export interface RoleUserRow {
  id: number;
  username: string;
  nama: string;
  profesi: string | null;
  jabatan: string | null;
  aktif: boolean;
}

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

const BASE = "/profession-role";

export default {
  async catalog(): Promise<PrivilegeCatalogItem[]> {
    const res = await handle(http.getData("/privilege-catalog"));
    return res.data.data || [];
  },

  async list(search = ""): Promise<ProfessionRoleRow[]> {
    const res = await handle(
      http.getDataParam(BASE, { params: search ? { search } : {} })
    );
    return res.data.data || [];
  },

  async show(id: string): Promise<ProfessionRoleRow> {
    const res = await handle(http.getData(`${BASE}/${id}`));
    return res.data.data;
  },

  async create(payload: Partial<ProfessionRoleRow>): Promise<ProfessionRoleRow> {
    const res = await handle(http.postData(BASE, payload));
    return res.data.data;
  },

  async update(
    id: string,
    payload: Partial<ProfessionRoleRow>
  ): Promise<ProfessionRoleRow> {
    const res = await handle(http.putData(`${BASE}/${id}`, payload));
    return res.data.data;
  },

  async remove(id: string): Promise<void> {
    await handle(http.deleteData(`${BASE}/${id}`));
  },

  async users(id: string): Promise<RoleUserRow[]> {
    const res = await handle(http.getData(`${BASE}/${id}/users`));
    return res.data.data || [];
  },

  async attachUsers(id: string, userIds: number[]): Promise<void> {
    await handle(http.postData(`${BASE}/${id}/users`, { user_ids: userIds }));
  },

  async detachUser(id: string, userId: number): Promise<void> {
    await handle(http.deleteData(`${BASE}/${id}/users/${userId}`));
  }
};
